module.exports = __webpack_public_path__ + "img/solution4.8d28daf0.jpg";